import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  flex-direction: column;
`;

export const StyledMarkdown = styled.div`
  h2 {
    font-size: ${({ theme }) => theme.fontSizePalette.large};
    margin-bottom: 10px;
    color: ${({ theme }) => theme.colorPalette.grey.grey10};
  }

  ol {
    list-style: auto;
    margin-left: 11px;
  }

  ul {
    list-style: disc;
    margin-left: 11px;
  }

  ul li,
  ol li {
    margin: 0 0 5px 5px;
  }

  ul,
  p,
  ol {
    margin-bottom: 10px;
  }

  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;

  pre {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 12px;
    overflow-x: auto;
    margin: 10px 0;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    line-height: 1.4;
  }

  code {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 3px;
    padding: 2px 4px;
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    color: #495057;
  }

  pre code {
    background-color: transparent;
    border: none;
    padding: 0;
    color: #495057;
  }

  strong {
    font-weight: 500;
  }

  .link {
    display: inline-block;
    border: 1px solid ${({ theme }) => theme.colorPalette.turquoise.dark};
    color: ${({ theme }) => theme.colorPalette.turquoise.dark};
    border-radius: 15px;
    padding: 2px 8px;
    margin: 0 4px;
    font-size: ${({ theme }) => theme.fontSizePalette.small};
    vertical-align: middle;
    margin: 5px 0;
    max-width: 100%;

    svg {
      margin-left: 5px;
      vertical-align: middle;
    }
  }

  .link:hover {
    background-color: ${({ theme }) => theme.colorPalette.turquoise.accent2};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colorPalette.turquoise.dark};
    max-width: calc(100% - 19px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 15px 0;
    background-color: ${({ theme }) => theme.colorPalette.white};
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
  }

  th {
    background-color: #e8f4f5;
    color: ${({ theme }) => theme.colorPalette.grey.grey4};
    font-weight: 600;
    text-align: left;
    padding: 12px 15px;
    border-bottom: 1px solid #dee2e6;
  }

  td {
    padding: 10px 15px;
    border-bottom: 1px solid #dee2e6;
  }

  tr:nth-child(even) {
    background-color: #f8f9fa;
  }

  tr:last-child td {
    border-bottom: none;
  }

  th:first-child,
  td:first-child {
    border-left: none;
  }

  th:last-child,
  td:last-child {
    border-right: none;
  }
`;

export const LoadingMessageContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ChatHistory = styled.div`
  overflow-y: auto;
  flex: 1;
  padding: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-x: visible;
  border-bottom: none;
`;

export const MessageBlock = styled.div`
  line-height: 1.5;
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const UserQuestion = styled.div`
  color: ${({ theme }) => theme.colorPalette.grey.grey10};
  margin-bottom: 20px;
  border-radius: 12px 0 12px 12px;
  padding: 18px 22px;
  max-width: 75%;
  margin-left: auto;
  background: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.dark : theme.colorPalette.turquoise.light};
`;

export const BotAnswer = styled.div`
  color: ${({ theme }) => theme.colorPalette.black};
  width: 100%;
  margin-bottom: 20px;
`;

export const Answer = styled.div`
  flex: 1;
`;

export const ResponseTime = styled.div`
  margin-top: 10px;
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  color: ${({ theme }) => theme.colorPalette.grey.grey6};
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 12px;
`;

export const WalkthroughContainer = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
`;

export const WalkthroughLink = styled.div`
  display: inline-block;
  cursor: pointer;
  text-decoration: underline;
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
`;
